import { Component, createRef } from 'react'
import Results from '~/components/Search/Results'
import styles from '~/styles/search.module.css'
import types from '~/types/search.ts'

export default class Search extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
			isFocused: false,
			value: '',
			result: null,
		}
		this._limit = 1000
		this._inputRef = createRef()
		if (this.props.setCallback) {
			this.props.setCallback(this._onCallback.bind(this))
		}
	}
	
	render(): JSX.Element {
		return (
			<div
				className={styles.main}
			>
				<input
					type="text"
					placeholder={this.props.placeholder || 'Search'}
					value={this.state.value}
					className={(this.state.value === this.state.result) ? styles.resultative : null}
					ref={this._inputRef}
					onFocus={this._onFocus.bind(this)}
					onBlur={this._onBlur.bind(this)}
					onChange={this._onChange.bind(this)}
					onKeyDown={this._onKeyDown.bind(this)}
					onClick={this._onClick.bind(this)}
				/>
				<Results
					show={this.state.isFocused}
					results={this.state.results || this.props.keys}
					onFound={this._onFound.bind(this)}
					selectedItem={this.state.selectedItem}
					selectedId={this.state.selectedId || null}
					inputRef={this._inputRef}
					limit={this._limit}
				/>
			</div>
		)
	}
	
	private _onChange(event): void {
		const value = event.target.value
		this.setState({ value })
		if (this.props.onValue) {
			this.props.onValue(event.target.value)
		}
		if (this.props.onFound) {
			this.props.onFound(null)
		}
		let results = []
		this.props.keys.forEach(key => {
			if (key.toLowerCase().includes(value.toLowerCase())) {
				results.push(key)
			}
		})
		if (results.length) {
			this.setState({ results })
		} else {
			this.setState({ results: this.props.keys })
		}
	}
	
	private _onFocus(): void {
		this.setState({ isFocused: true })
		setTimeout(() => {
			const resultsDiv = this._inputRef.current?.parentElement?.querySelector('div')
			if (resultsDiv) {
				const currentBottom = resultsDiv.getBoundingClientRect().bottom
				if (currentBottom > (this.state.maxBottom || 0)) {
					this.setState({ maxBottom: currentBottom })
					if (this.props.onHeight) {
						this.props.onHeight(currentBottom)
					}
				}
			}
		})
	}
	
	private _onBlur(): void {
		setTimeout(() => {
			if ((Date.now() - (this.state.onFoundDate || 0)) > 500) {
				this.setState({ isFocused: false })
				this._clearSearch()
			}
		}, 250)
	}
	
	private _onClick(event): void {
		event.stopPropagation()
		this.setState({ isFocused: true })
	}
	
	private _onKeyDown(event): void {
		if ([ 38, 40 ].includes(event.which)) {
			if (!this.state.isFocused) {
				this.setState({ isFocused: true })
			}
			const results = (this.state.results || this.props.keys || [])
			let defaultSearchSelectedId = 0
			if (event.which === 38) {
				defaultSearchSelectedId = results.length - 1
				if (defaultSearchSelectedId > this._limit - 1) {
					defaultSearchSelectedId = this._limit - 1
				}
			}
			let nextSearchSelectedId = null
			if (this.state.selectedId || this.state.selectedId === 0) {
				nextSearchSelectedId = this.state.selectedId + 1
				if (event.which === 38) {
					nextSearchSelectedId = this.state.selectedId - 1
				}
				if (nextSearchSelectedId > this._limit - 1) {
					nextSearchSelectedId = 0
				}
				if (nextSearchSelectedId < 0) {
					nextSearchSelectedId = this._limit - 1
				}
			}
			const selectedId = (nextSearchSelectedId === null ? defaultSearchSelectedId : nextSearchSelectedId)
			this.setState({
				selectedId,
				selectedItem: results[selectedId],
			})
		} else if (event.which === 27) {
			event.stopPropagation()
			this.setState({ isFocused: false })
		} else if (event.which === 13) {
			if (this.state.selectedItem) {
				this._onFound(this.state.selectedItem)
			} else {
				if (this.props.doAction) {
					this.props.doAction()
				}
			}
		}
	}
	
	private _onFound(result): void {
		this._inputRef?.current?.focus()
		this.setState({
			value: result,
			result,
			onFoundDate: Date.now(),
			isFocused: false,
		})
		this._clearSearch()
		if (this.props.onFound) {
			this.props.onFound(result)
		}
	}
	
	private _clearSearch(): void {
		this.setState({
			selectedId: null,
			selectedItem: null,
		})
	}
	
	private _onCallback(): void {
		this._clearSearch()
		this.setState({
			isFocused: false,
			value: '',
			result: null,
			results: this.props.keys,
		})
	}
}